import {Request} from '@/apis'

export function page(params) {
    return Request.get("/dict/page", params);
}

export function getObj(id) {
    return Request.get("/dict/" + id);
}

export function saveObj(obj) {
    return Request.post("/dict", obj);
}

export function updateObj(obj) {
    return Request.put("/dict", obj);
}

export function deleteObj(id) {
    return Request.delete("/dict/" + id);
}

export function itemPage(params) {
    return Request.get("/dict/item/page", params);
}

export function getItem(id) {
    return Request.get("/dict/item/" + id);
}

export function saveItem(obj) {
    return Request.post("/dict/item", obj);
}

export function updateItem(obj) {
    return Request.put("/dict/item", obj);
}

export function deleteItem(id) {
    return Request.delete("/dict/item/" + id);
}

export function itemByCodes(params) {
    return Request.get("/dict/itemByCodes", params);
}
